export default {
  common: {
    edited: 'Bearbeitet',
    error: {
      general: 'Hoppla!',
      failedToOpenMaps: 'Fehler beim Öffnen der Karte',
      failedToOpenLink:
        'Fehler beim Öffnen des Links. Auf diesem Gerät ist kein Webbrowser verfügbar.',
      reportTooMany: 'Du hast in letzter Zeit viele Meldungen gesendet. Warte kurz und versuch es noch einmal.',
      reportFailed: 'Das Meldeformular konnte nicht geöffnet werden. Versuch es noch einmal.',
      reportUnavailable: 'Dieser Inhalt ist nicht mehr verfügbar und kann nicht gemeldet werden.',
      popupBlocked:
        'Dein Browser hat das Öffnen des Formulars blockiert. Erlaube Pop-ups für diese Seite und versuch es noch einmal.',
      ipBlocked:
        'Deine IP-Adresse wurde aufgrund verdächtiger Aktivitäten gesperrt. Wenn du glaubst, dass dies ein Fehler ist, wende dich bitte an den Support.',
      crashTitle: 'Hoppla! Etwas ist schiefgelaufen',
      crashSubtitle: 'Wir wurden benachrichtigt und kümmern uns darum.',
      crashReload: 'Neu laden',
      crashRetry: 'Erneut versuchen',
    },
    updateBanner: {
      message: 'Wir haben einige Verbesserungen vorgenommen',
      refresh: 'Neu laden',
    },
    connection: {
      offline: 'Keine Internetverbindung',
      connecting: 'Verbinden...',
    },
    success: 'Erfolg!',
    follow: 'Folgen',
    unfollow: 'Nicht mehr folgen',
    followed: 'Gefolgt',
    message: 'Nachricht',
    empty: 'Hier gibt es noch nichts zu sehen',
    post: 'Beitrag',
    comment: 'Kommentar',
    photo: 'Foto',
    month: 'Monat',
    year: 'Jahr',
    cancel: 'Abbrechen',
    continue: 'Fortfahren',
    back: 'Zurück',
    delete: 'Löschen',
    update: 'Aktualisieren',
    saveChanges: 'Änderungen speichern',
    scrollToTop: 'Nach oben scrollen',
    undo: 'Rückgängig',
    report: 'Melden',
    openingForm: 'Formular wird geöffnet...',
    accept: 'Akzeptieren',
    reject: 'Ablehnen',
    retry: 'Wiederholen',
    send: 'Senden',
    unblock: 'Entsperren',
    comingSoon: 'Demnächst verfügbar',
    loading: 'Wird geladen...',
    done: 'Fertig',
    clear: 'Löschen',
    clearAll: 'Zurücksetzen',
    search: 'Suchen...',
    share: {
      success: 'Erfolgreich geteilt',
      error: 'Fehler beim Teilen',
      copied: 'Link in die Zwischenablage kopiert',
      shareLink: 'Link teilen',
      url: 'URL',
      copy: 'Kopieren',
      open: 'Öffnen',
    },
    validation: {
      min: 'Mindestens {{minLength}} Zeichen verwenden',
      max: 'Höchstens {{maxLength}} Zeichen verwenden',
      required: 'Dieses Feld ist erforderlich',
      requiredField: '{{field}} ist erforderlich',
    },
    filters: {
      myType: 'mein Typ',
      all: 'Filter',
    },
    relativeTime: {
      now: 'jetzt',
      justNow: 'gerade eben',
    },
  },
  myTypeFilter: {
    title: 'Mein-Typ-Filter',
    enableOption: 'Aktivieren',
    disableOption: 'Deaktivieren',
    statusEnabled: 'An',
    statusDisabled: 'Aus',
    configure: 'Konfigurieren…',
    configureTitle: 'Mein-Typ-Filter konfigurieren',
    enabled: 'Mein-Typ-Filter aktiviert',
    disabled: 'Mein-Typ-Filter deaktiviert',
    enableError: 'Filter konnte nicht aktiviert werden',
    disableError: 'Filter konnte nicht deaktiviert werden',
    infoTitle: 'Was ist der Mein-Typ-Filter?',
    infoDescription:
      'Lege deine Präferenzen einmal fest und die Listen für Beiträge, Mitglieder und Fotos zeigen automatisch nur Personen an, die deinen Kriterien entsprechen. Du kannst diesen Filter jederzeit aktivieren oder deaktivieren.',
    preview: 'Vorschau',
    apply: 'Anwenden',
    appliedSuccess: 'Filtereinstellungen gespeichert',
    appliedError: 'Filtereinstellungen konnten nicht gespeichert werden',
    filteredOutPercent: '{{percent}}% der Mitglieder herausgefiltert',
    filterWarning: 'Das Herausfiltern von zu vielen Personen kann deine Erfahrung beeinträchtigen.',
  },
  sensitiveContent: {
    title: 'Sensible Inhalte',
    statusHidden: 'Versteckt',
    statusVisible: 'Sichtbar',
    configure: 'Konfigurieren...',
  },
  navigation: {
    feeds: 'Feeds',
    people: 'Mitglieder',
    photo: 'Foto',
    photos: 'Fotos',
    events: 'Veranstaltungen',
    discover: 'Entdecken',
  },
  communities: {
    myCommunities: 'Meine Communities',
    menu: {
      remove: 'Aus Meine Communities entfernen',
    },
    delete: {
      confirmTitle: 'Community entfernen',
      confirmMessage:
        'Möchtest du {{communityName}} wirklich aus Meine Communities entfernen? Du kannst dich später erneut anmelden.',
      success: 'Community entfernt',
      error: 'Community konnte nicht entfernt werden',
    },
    visitSite: 'Besuche {{communityName}}',
  },
  auth: {
    createAccount: 'Konto erstellen',
    signIn: {
      title: 'Anmelden',
      welcomeBack: 'Willkommen zurück!',
      heading: 'Bei {{communityName}} anmelden',
      usernameLabel: 'Benutzername',
      usernamePlaceholder: 'Benutzernamen eingeben',
      usernameNotFound: 'Benutzername nicht gefunden',
      passwordLabel: 'Passwort',
      passwordPlaceholder: 'Passwort eingeben',
      passwordIncorrect: 'Falsches Passwort oder Benutzername',
      rememberMe: 'Angemeldet bleiben',
      forgotPassword: 'Passwort vergessen?',
      submit: 'Einloggen',
      submitting: 'Anmeldung...',
      noAccount: 'Noch kein Konto?',
      signUp: 'Registrieren',
      loginFailedToast: 'Anmeldung fehlgeschlagen',
      removeCredentialsError: 'Fehler beim Entfernen der Anmeldedaten',
      unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten',
    },
    signUp: {
      redirectHelper:
        'Du wirst zu unserer älteren {{communityName}}‑Website weitergeleitet, um ein Konto zu erstellen. Sobald du ein Konto erstellt hast, kannst du zu dieser App zurückkehren und dich anmelden.',
      successToast: 'Konto erstellt. Wir haben dir dein Passwort per E‑Mail gesendet.',
    },
    forgotPassword: {
      title: 'Passwort vergessen',
      redirectHelper:
        'Du wirst zu unserer älteren {{communityName}}‑Website weitergeleitet, um dein Passwort zurückzusetzen. Sobald du dein neues Passwort per E‑Mail erhalten hast, kehre zur App zurück, um dich anzumelden.',
      successToast: 'Wir haben dir ein neues Passwort per E‑Mail gesendet.',
    },
  },
  feeds: {
    global: 'Globaler Feed',
    global_short: 'Global',
    local: 'Lokaler Feed',
    local_short: 'Lokal',
    network: 'Folge-Feed',
    network_short: 'Folge',
    search: 'Suche',
    search_short: 'Suchen',
    search_placeholder: 'Suche in Beiträgen',
    empty: 'Entschuldigung, keine Ergebnisse gefunden',
    latestSearches: 'Aktuelle Suchen',
    popularSearches: 'Beliebte Suchen',
    popularHashtags: 'Beliebte Hashtags',
    onlineMembers: 'Jetzt online',
    profileVisitors: 'Haben mein Profil besucht',
    searchMembersHint: 'Suchst du jemanden?',
    searchMembersLink: 'Mitglieder suchen',
    pinned: 'Als Standard-Feed festgelegt',
    unpinned: 'Globaler Feed als Standard wiederhergestellt',
    alreadyDefault:
      'Das ist bereits dein Standard-Feed. Wechsle zu einem anderen Feed, um ihn zu ändern.',
    radius: {
      title: 'Radius',
      km: 'km',
      mi: 'mi',
    },
  },
  messages: {
    title: 'Nachrichten',
    inbox: 'Posteingang',
    inboxBadgeUnreadCaption_one: 'ungelesen',
    inboxBadgeUnreadCaption_other: 'ungelesen',
    inboxBadgeMessagesCaption_one: 'Nachricht',
    inboxBadgeMessagesCaption_other: 'Nachrichten',
    unread: 'Nicht gelesen',
    online: 'Online',
    deleted: 'Gelöscht',
    emptyDeleted: 'Keine gelöschten Unterhaltungen in den letzten 90 Tagen',
    search: 'Suchen',
    search_placeholder: 'Gib einen Benutzernamen ein',
    empty: 'Keine Nachrichten zum Anzeigen',
    conversation: 'Unterhaltung',
    emptyConversation: 'Keine Konversationselemente zum Anzeigen',
    typeMessage: 'Nachricht eingeben...',
    photoMessage: 'hat ein Foto gesendet',
    gifMessage: 'hat ein GIF gesendet',
    stickerMessage: 'hat einen Sticker gesendet',
    clipMessage: 'hat einen Clip gesendet',
    youSentPhoto: 'Du hast ein Foto gesendet',
    youSentGif: 'Du hast ein GIF gesendet',
    youSentSticker: 'Du hast einen Sticker gesendet',
    youSentClip: 'Du hast einen Clip gesendet',
    replyFailed: 'Antwort konnte nicht gesendet werden',
    compose: {
      messageToUser: 'Nachricht an {{userName}}',
      enterMessage: 'Gib deine Nachricht ein...',
    },
    errors: {
      failedToLoad: 'Konversation konnte nicht geladen werden',
      failedToSend: 'Nachricht konnte nicht gesendet werden',
    },
    success: {
      messageSent: 'Nachricht erfolgreich gesendet',
    },
    loadOlderMessages: 'Ältere Nachrichten laden',
    loadingOlderMessages: 'Ältere Nachrichten werden geladen...',
    loadingNewerMessages: 'Neuere Nachrichten werden geladen...',
    markAsRead: {
      error: 'Nachricht konnte nicht als gelesen markiert werden',
    },
    markAsUnread: {
      error: 'Nachricht konnte nicht als ungelesen markiert werden',
    },
    delete: {
      success: 'Nachricht erfolgreich gelöscht',
      error: 'Nachricht konnte nicht gelöscht werden',
    },
    undelete: {
      success: 'Nachricht erfolgreich wiederhergestellt',
      error: 'Nachricht konnte nicht wiederhergestellt werden',
    },
    menu: {
      markRead: 'Als gelesen markieren',
      markUnread: 'Als ungelesen markieren',
      viewProfile: 'Profil anzeigen',
      deleteConversation: 'Unterhaltung löschen',
      restoreConversation: 'Unterhaltung wiederherstellen',
      reportConversation: 'Unterhaltung melden',
    },
    copy: {
      success: 'Inhalt in die Zwischenablage kopiert',
      error: 'Fehler beim Kopieren des Inhalts',
      noContent: 'Kein Inhalt zum Kopieren',
    },
    download: {
      label: 'Foto speichern',
      success: 'Foto in deiner Mediathek gespeichert',
      error: 'Foto konnte nicht gespeichert werden',
      permissionDenied:
        'Zum Speichern von Fotos ist die Berechtigung für die Fotomediathek erforderlich',
    },
    unreadMessage: 'Ungelesene Nachricht',
    uploadPhoto: 'Bild hochladen',
    dropImageToSend: 'Bild zum Senden ablegen',
    dropImageToSendToUser: 'Bild ablegen, um an {{userName}} zu senden',
    sendPhoto: 'Foto senden',
    photoUploadFailed: 'Bild-Upload fehlgeschlagen',
    photoUploadSuccess: 'Bild erfolgreich hochgeladen',
    selectPhoto: 'Fotos',
    takePhoto: 'Kamera',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    cameraPermissionNotGranted: 'Kamera-Berechtigung nicht erteilt',
    mediaLibraryPermissionNotGranted: 'Medienbibliothek-Berechtigung nicht erteilt',
    failedToPickImage: 'Bildauswahl fehlgeschlagen',
    imageTooLarge: 'Das Bild ist zu groß. Die maximale Größe beträgt {{size}}MB.',
    adminClosedInfo:
      'Diese Unterhaltung ist geschlossen. Für weiteres Vorgehen öffne ein Support‑Ticket und füge relevante Details hinzu.',
    contactSupport: 'Support kontaktieren',
    newAccountNotice: {
      title: '{{name}} ist neu hier',
      body: 'Lass dir Zeit, neue Mitglieder kennenzulernen. Sei vorsichtig mit persönlichen Infos und werde misstrauisch, wenn du gebeten wirst, den Chat auf Telegram, WhatsApp, SMS oder einen anderen Messaging-Dienst zu verlegen.',
    },
  },
  people: {
    nearby: 'Mitglieder in der Nähe',
    nearby_short: 'In der Nähe',
    online: 'Mitglieder online',
    online_short: 'Online',
    birthdays: 'Geburtstage',
    birthdays_short: 'Geburtstage',
    new: 'Neue Mitglieder',
    new_short: 'Neu',
    following: 'Mitglieder, denen ich folge',
    following_short: 'Gefolgt',
    followers: 'Meine Follower',
    followers_short: 'Follower',
    visitors: 'Meine Besucher',
    visitors_short: 'Besucher',
    search: 'Mitgliedersuche',
    search_short: 'Suche',
    empty: 'Entschuldigung, das ist leer',
    displayModeCompact: 'Kompakte Ansicht',
    displayModeRegular: 'Normale Ansicht',
    nearbyFilter: {
      online: 'Online',
      recent: 'Kürzlich',
      active: 'Letzte 90 Tage',
      newmembers: 'Neu',
      all: 'Alle',
    },
  },
  search: {
    username: 'Benutzername',
    usernamePlaceholder: 'Nach Benutzernamen suchen',
    location: 'Standort',
    nearMe: 'In meiner Nähe',
    anywhere: 'Überall',
    customLocation: 'Benutzerdefinierter Standort',
    ranges: 'Bereiche',
    age: 'Alter',
    bmi: 'BMI',
    filters: 'Filter',
    additional: 'Zusätzliche Filter',
    hasPhotos: 'Hat Fotos',
    hasPrivatePhotos: 'Hat private Fotos',
    isOnline: 'Derzeit online',
    isActive: 'In den letzten 90 Tagen aktiv',
    isNew: 'Neues Mitglied',
    isFollower: 'Folgt mir',
    imFollowing: 'Gefolgt',
    imTheirBodyType: 'Interessiert an meinem Körpertyp',
    clearAll: 'Zurücksetzen',
    search: 'Suchen',
    anything: 'Egal',
    to: 'bis',
    andUnder: 'und darunter',
    andAbove: 'und darüber',
    multipleSelected: '{{count}} ausgewählt',
    selectedCount: '{{count}} ausgewählt',
    noneSelected: 'Keine ausgewählt',
    selectAtLeastOneFilter: 'Bitte wähle mindestens einen Filter für deine Suche',
    restoredFiltersTitle: 'Filter wiederhergestellt',
    restoredFiltersDescription:
      'Die Filter deiner letzten Suche wurden wiederhergestellt. Möchtest du neu anfangen? Klicke auf den Zurücksetzen-Button unten.',
  },
  discover: {
    seeMore: 'Mehr anzeigen',
    tabBarHintLead: 'Deine Tabs haben ein geheimes Menü',
    tabBarHintBody: 'Gedrückt halten, wischen, und du springst mit einem Zug zu jeder Liste.',
    sectionSubtitles: {
      photos: {
        latest: 'Öffentliche Fotos aus der Community',
        network: 'Öffentliche Fotos von Mitgliedern, denen du folgst',
        private: 'Private Fotos von Mitgliedern, die dich reinlassen',
        favorites: 'Fotos, die dir gefallen haben',
      },
      events: {
        upcoming: 'Alle bevorstehenden Community-Events',
        nearby: 'Bevorstehende Events im Umkreis von {{distance}}',
        network: 'Events, an denen Mitglieder teilnehmen, denen du folgst',
        past: 'Archivierte vergangene Community-Events',
      },
    },
  },
  photos: {
    photoOf: 'Foto von {{userName}}',
    posted: 'Veröffentlicht',
    latest: 'Neueste Fotos (Alle)',
    latest_short: 'Neueste',
    network: 'Neueste Fotos (Folge)',
    network_short: 'Folge',
    private: 'Neueste Fotos (Privat)',
    private_short: 'Privat',
    favorites: 'Lieblingsfotos',
    favorites_short: 'Favoriten',
    addPublicPhoto: 'Öffentliches Foto hinzufügen',
    addPrivatePhoto: 'Privates Foto hinzufügen',
    dropToUploadPublic: 'Ablegen, um in Öffentlich hochzuladen',
    dropToUploadPrivate: 'Ablegen, um in Privat hochzuladen',
    captionPlaceholder: 'Untertitel hinzufügen (optional)',
    uploadSuccess: 'Foto hochgeladen',
    uploadFailed: 'Foto-Upload fehlgeschlagen',
    uploadingImage: 'Bild wird hochgeladen...',
    policyLink: 'Lies unsere Fotorichtlinie',
    artworkNotice:
      'KI-generierte Bilder müssen als solche gekennzeichnet und nur sparsam veröffentlicht werden.',
    artworkNoticeFerzu:
      'Kunstwerke müssen kreditiert werden. KI-generierte Bilder sind nicht erlaubt.',
    empty: 'Keine Fotos anzuzeigen',
    sensitiveReminder: {
      title: 'Sensible und ungeprüfte Fotos sind ausgeblendet',
      body: 'Deine Sicherheitseinstellungen blenden sensible und ungeprüfte Fotos aus. Du kannst das jederzeit unter Filtern oder in den Einstellungen ändern.',
      action: 'Sicherheitsoptionen ansehen',
      dismiss: 'Ausblenden',
    },
  },
  photo: {
    menu: {
      editCaption: 'Bildunterschrift bearbeiten',
      useAsProfilePhoto: 'Als Profilfoto verwenden',
      moveToPrivate: 'In privaten Ordner verschieben',
      requestReview: 'Überprüfung anfordern',
      report: 'Foto melden',
      delete: 'Foto löschen',
    },
    caption: {
      placeholder: 'Bildunterschrift hinzufügen (optional)',
      updateSuccess: 'Bildunterschrift aktualisiert',
      updateError: 'Aktualisierung der Bildunterschrift fehlgeschlagen',
    },
    profile: {
      confirmTitle: 'Als Profilfoto verwenden',
      confirmMessage: 'Möchtest du dieses Bild wirklich als Profilfoto verwenden?',
      setSuccess: 'Profilfoto aktualisiert',
      setError: 'Profilfoto konnte nicht aktualisiert werden',
    },
    private: {
      success: 'Foto in privaten Ordner verschoben',
      error: 'Foto konnte nicht in den privaten Ordner verschoben werden',
    },
    locked: {
      message:
        'Upgrade auf {{premiumPlan}}, um unbegrenzt Fotos in Listen und im Vollbildmodus anzuzeigen.',
    },
    review: {
      requestSuccess: 'Überprüfung angefordert',
      requestError: 'Überprüfungsanfrage fehlgeschlagen',
      dialogTitle: 'Fotobewertung',
      dialogIntro:
        'Wenn du glaubst, dass unser KI-basiertes Bewertungssystem oder menschliche Prüfer einen Fehler bei der Einstufung deines Fotos gemacht haben, oder wenn du ein Foto aus deinem privaten Ordner in Öffentlich verschieben möchtest, kannst du eine manuelle Überprüfung anfordern, damit das Foto erneut bewertet wird. Bitte beachte, dass jedes Foto nur einmal überprüft werden kann und der Vorgang einige Stunden dauern kann.',
      possibleRatingsTitle: 'Mögliche Bewertungen sind:',
    },
    delete: {
      confirmTitle: 'Foto löschen',
      confirmMessage:
        'Bist du sicher, dass du dieses Foto löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
      success: 'Foto erfolgreich gelöscht',
      error: 'Foto konnte nicht gelöscht werden',
    },
  },
  events: {
    upcoming: 'Kommende Events',
    upcoming_short: 'Kommende',
    nearby: 'Events in der Nähe',
    nearby_short: 'In der Nähe',
    network: 'Netzwerk-Events',
    network_short: 'Netzwerk',
    attending: 'Teilnehmend',
    attend: 'Teilnehmen',
    unattend: 'Nicht teilnehmen',
    follow: 'Folgen',
    following: 'Gefolgt',
    attendees: 'Teilnehmer',
    attendees_one: 'Teilnehmer',
    attendees_other: 'Teilnehmer',
    attendees_short: 'Teilnehmer',
    followers: 'Follower',
    followers_one: 'Follower',
    followers_other: 'Follower',
    followers_short: 'Follower',
    past: 'Vergangene Events',
    past_short: 'Vergangene',
    organizer: 'Organisator',
    curator: 'Kurator',
    curatorNotice:
      'Diese Person pflegt die Event-Listungen. Bitte melde Unstimmigkeiten. Wenn du der Veranstalter bist, kannst du die Seite übernehmen, indem du {{communityName}} kontaktierst.',
    date_time: 'Datum & Uhrzeit',
    location: 'Ort',
    website: 'Website',
    empty: 'Keine Events vorhanden',
    noEventsForMember: 'Noch keine Events',
    attendeesCount_one: '{{count}} Teilnehmer',
    attendeesCount_other: '{{count}} Teilnehmer',
    attendSuccess: 'Du nimmst an diesem Event teil',
    unattendSuccess: 'Du nimmst nicht mehr an diesem Event teil',
    attendError: 'Teilnahme konnte nicht bestätigt werden',
    unattendError: 'Teilnahme konnte nicht storniert werden',
    followError: 'Event konnte nicht gefolgt werden',
    unfollowError: 'Event konnte nicht entfolgt werden',
    createSuccess: 'Event erstellt',
    updateSuccess: 'Event aktualisiert',
    createError: 'Event konnte nicht erstellt werden',
    updateError: 'Event konnte nicht aktualisiert werden',
    deleteSuccess: 'Event gelöscht',
    deleteError: 'Event konnte nicht gelöscht werden',
    deleteEvent: 'Event löschen',
    deleteConfirmTitle: 'Event löschen?',
    deleteConfirmMessage:
      'Bist du sicher, dass du dieses Event löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
    createEvent: 'Neues Event',
    editEvent: 'Event bearbeiten',
    form: {
      code: 'Event-Code',
      codePlaceholder: 'z.B. mein-event-2026',
      codeHint:
        'Buchstaben, Zahlen, Bindestriche und Unterstriche. Darf nicht mit einer Zahl beginnen.',
      name: 'Eventname',
      namePlaceholder: 'Eventname eingeben',
      nameHint:
        'Vermeide es, das Datum oder den Monat in den Eventnamen aufzunehmen. Wenn nötig, füge es am Ende des Namens hinzu.',
      startDate: 'Startdatum',
      endDate: 'Enddatum (optional)',
      selectDate: 'Datum auswählen',
      startTime: 'Startzeit',
      endTime: 'Endzeit',
      selectTime: 'Uhrzeit festlegen',
      timesError: 'Beide Zeiten oder keine angeben',
      location: 'Standort',
      selectLocation: 'Standort auswählen',
      venue: 'Ort, Veranstaltungshalle oder Hotel',
      venuePlaceholder: 'z.B. Kongresszentrum',
      website: 'Website',
      websitePlaceholder: 'https://deinewebsite.com',
      websiteError: 'Die Website-URL muss mit https:// beginnen',
      details: 'Event-Details',
      detailsPlaceholder: 'Beschreibe das Event...',
      organizer: 'Ich bin der Organisator dieses Events',
      save: 'Änderungen speichern',
      create: 'Event erstellen',
      required: 'Erforderlich',
    },
    addToCalendar: 'Zum Kalender hinzufügen',
    share: {
      title: 'Schau dir dieses Event an',
      message: 'Schau dir {{eventName}} an',
      shareEvent: 'Event teilen',
    },
  },
  post: {
    like_one: '{{count}} Gefällt mir',
    like_other: '{{count}} Gefällt mir',
    comment_one: '{{count}} Kommentar',
    comment_other: '{{count}} Kommentare',
    addComment: 'Kommentieren',
    announcement: 'Ankündigung',
    singlePost: 'Beitrag',
    newPost: 'Neuer Beitrag',
    placeholder: 'Was denkst du?',
    compose: {
      wallPlaceholder: 'Schreibe an die Pinnwand von {{userName}}...',
    },
    publish: 'Veröffentlichen',
    createSuccess: 'Dein Beitrag wurde veröffentlicht',
    createError: 'Beitrag konnte nicht veröffentlicht werden',
    editSuccess: 'Dein Beitrag wurde aktualisiert',
    editError: 'Beitrag konnte nicht aktualisiert werden',
    readMore: 'Weiterlesen',
    featuredPhoto: {
      warningWithReset:
        'Es scheint, dass du sehr kürzlich ein anderes Foto gepostet hast, was bedeutet, dass dieses Foto nicht im globalen Feed hervorgehoben wird, es sei denn, du wartest {{minutes}} Minuten, um es zu posten',
    },
    menu: {
      edit: 'Beitrag bearbeiten',
      dismissAnnouncement: 'Ankündigung ausblenden',
      share: 'Beitrag teilen',
      stopNotifications: 'Benachrichtigungen deaktivieren',
      resumeNotifications: 'Benachrichtigungen fortsetzen',
      report: 'Beitrag melden',
      delete: 'Beitrag löschen',
    },
    mute: {
      title: 'Benachrichtigungen deaktivieren für wie lange?',
      oneHour: '1 Stunde',
      eightHours: '8 Stunden',
      oneDay: '24 Stunden',
      indefinitely: 'Unbegrenzt',
      success: 'Benachrichtigungen für diesen Beitrag erfolgreich deaktiviert',
      error: 'Fehler beim Deaktivieren der Benachrichtigungen für diesen Beitrag',
    },
    unmute: {
      success: 'Benachrichtigungen für diesen Beitrag erfolgreich fortgesetzt',
      error: 'Fehler beim Fortsetzen der Benachrichtigungen für diesen Beitrag',
    },
    getMutedState: {
      error: 'Fehler beim Abrufen des Benachrichtigungsstatus',
    },
    dismissAnnouncement: {
      success: 'Ankündigung ausgeblendet',
      error: 'Fehler beim Ausblenden der Ankündigung',
    },
    delete: {
      confirmTitle: 'Beitrag löschen',
      confirmMessage:
        'Bist du sicher, dass du den Beitrag löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
      success: 'Beitrag erfolgreich gelöscht',
      error: 'Fehler beim Löschen des Beitrags',
    },
    share: {
      title: 'Beitrag teilen',
      message: 'Schau dir diesen Beitrag von {{userName}} an',
      success: 'Beitrag erfolgreich geteilt',
      copied: 'Link in die Zwischenablage kopiert',
      error: 'Fehler beim Teilen des Beitrags',
      shareLink: 'Link teilen',
      copy: 'Kopieren',
      open: 'Öffnen',
      postUrl: 'Beitrags-URL',
    },
  },
  media: {
    gif_button_label: 'GIF hinzufügen',
    no_results: 'Keine GIFs gefunden',
    failed_to_load: 'GIF konnte nicht geladen werden',
    search_placeholder: 'In {{provider}} suchen',
    powered_by: 'Bereitgestellt von {{provider}}',
  },
  comments: {
    title: 'Kommentare',
    titleOnItem: 'Kommentare zu {{itemType}} von {{userName}}',
    empty: 'Sei der Erste, der kommentiert!',
    add_placeholder: 'Kommentar hinzufügen...',
    added: 'Dein Kommentar wurde veröffentlicht',
    add_error: 'Fehler beim Veröffentlichen des Kommentars',
    editSuccess: 'Dein Kommentar wurde aktualisiert',
    editError: 'Fehler beim Aktualisieren des Kommentars',
    menu: {
      edit: 'Den Kommentar bearbeiten',
      report: 'Den Kommentar melden',
      delete: 'Den Kommentar löschen',
    },
    delete: {
      confirmTitle: 'Kommentar löschen',
      confirmMessage:
        'Sind Sie sicher, dass Sie den Kommentar löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      success: 'Kommentar erfolgreich gelöscht',
      error: 'Fehler beim Löschen des Kommentars',
    },
    viewMore_one: '{{count}} weiteren Kommentar anzeigen',
    viewMore_other: '{{count}} weitere Kommentare anzeigen',
  },
  likes: {
    title: 'Gefällt mir Angaben',
    titleOnItem: 'Gefällt mir Angaben zu {{itemType}} von {{userName}}',
  },
  notifications: {
    title: 'Benachrichtigungen',
    titleNative: 'Push-Benachrichtigungen',
    empty: 'Noch keine Benachrichtigungen',
    newNotifications: 'Neue Benachrichtigungen',
    clearAll: 'Alle löschen',
    clearAllConfirmTitle: 'Benachrichtigungen löschen',
    clearAllConfirmMessage:
      'Dadurch werden alle Benachrichtigungen ausgeblendet, einschließlich ausstehender Anfragen für den Zugriff auf deine privaten Fotos. Fortfahren?',
    clearAllSuccess: 'Benachrichtigungen gelöscht',
    clearAllError: 'Benachrichtigungen konnten nicht gelöscht werden',
    dismiss: 'Benachrichtigung ausblenden',
    dismissSuccess: 'Benachrichtigung ausgeblendet',
    dismissError: 'Benachrichtigung konnte nicht ausgeblendet werden',
    andOthers_one: '(und {{count}} andere)',
    andOthers_other: '(und {{count}} andere)',
    unlockAcceptSuccess: 'Entsperranfrage akzeptiert',
    unlockAcceptError: 'Fehler beim Akzeptieren der Entsperranfrage',
    unlockRejectSuccess: 'Entsperranfrage abgelehnt',
    unlockRejectError: 'Fehler beim Ablehnen der Entsperranfrage',
    permissionDisabledTitle: 'Push-Benachrichtigungen sind deaktiviert',
    permissionDisabledDescription:
      'Aktiviere Benachrichtigungen in den Einstellungen, damit du keine neuen Aktivitäten verpasst.',
    openSettings: 'Einstellungen öffnen',
  },
  settings: {
    title: 'Einstellungen',
    appearance: 'Erscheinungsbild',
    location: {
      title: 'Standort',
      current: 'Veröffentlicht als',
      mode: 'Ortsname',
      fixed: 'Fixiert',
      automatic: 'Automatisch',
      enable: 'Standort aktivieren...',

      enableHelp: 'Standort aktivieren',
      enableHelpBlocked: 'Dein Browser blockiert derzeit den Zugriff auf deinen Standort',
      enableHelpSteps:
        'Um ihn zu aktivieren, folge den Schritten unten:\n\n\u2022 Offne das Website-Informationsmenu neben der Adressleiste (Schloss-, Einstellungs- oder Info-Symbol).\n\u2022 Finde die Berechtigungen fur diese Website und suche die Standorteinstellung.\n\u2022 Andere den Standort auf Zulassen (oder Jedes Mal fragen).\n\u2022 Lade die Seite neu.',
      tips: 'Tipps und Datenschutz',
      fixedSet: 'Veröffentlichter Standort aktualisiert',
      fixedError: 'Standort konnte nicht festgelegt werden',
      searchPlaceholder: 'Stadt, PLZ oder Adresse',
      searchHint: 'Mindestens 2 Zeichen eingeben',
      noResults:
        'Keine passenden Orte. Prüfe die Schreibweise oder versuche es mit einer Stadt in der Nähe.',
      searchError: 'Fehler bei der Ortssuche',
      pickPlace: 'Ort auswählen',
      autoDescription:
        'Der Ortsname (Stadt), der in Ihrem Profil erscheint, wird aktualisiert, wenn Sie reisen',
    },
    account: {
      title: 'Konto',
      username: {
        title: 'Benutzernamen ändern',
        title_short: 'Benutzername',
        label: 'Neuer Benutzername',
        placeholder: 'Neuen Benutzernamen eingeben',
        helper:
          'Wähle einen neuen Benutzernamen mit 2–20 Zeichen, der mit einem Buchstaben beginnt. Erlaubt sind nur Buchstaben, Ziffern, - und _.',
        invalid: 'Ungültiger Benutzername',
        unavailable: 'Dieser Benutzername ist bereits vergeben',
        current: 'Benutzername:',
        updateAndSignOut: 'Aktualisieren und abmelden',
        successSignOut:
          'Benutzername aktualisiert. Bitte melde dich mit deinem neuen Benutzernamen erneut an.',
        error: 'Benutzername konnte nicht aktualisiert werden',
      },
      email: {
        title: 'E-Mail ändern',
        title_short: 'E-Mail',
        label: 'Neue E-Mail',
        placeholder: 'Neue E-Mail eingeben',
        changeExplanation:
          'Wir senden einen Bestätigungslink an Ihre neue Adresse. Die E-Mail wird nach Bestätigung geändert.',
        invalid: 'Gib eine gültige E‑Mail-Adresse ein',
        unavailable: 'Diese E-Mail wird bereits verwendet',
        current: 'E-Mail:',
        success: 'E-Mail-Änderung angefordert. Bitte Posteingang prüfen.',
        error: 'E-Mail konnte nicht aktualisiert werden',
      },
      password: {
        title: 'Passwort ändern',
        change: 'Passwort ändern',
        old: 'Aktuelles Passwort',
        new: 'Neues Passwort (mind. 6 Zeichen)',
        repeat: 'Neues Passwort wiederholen',
        mismatch: 'Passwörter stimmen nicht überein',
        oldRequired: 'Gib dein aktuelles Passwort ein',
        success: 'Passwort aktualisiert',
        error: 'Passwort konnte nicht aktualisiert werden',
      },
      delete: {
        title: 'Konto löschen',
        confirmLabel: 'Mit aktuellem Passwort bestätigen',
        confirmMessage: 'Diese Aktion ist dauerhaft. Passwort eingeben, um zu bestätigen.',
        placeholder: 'Aktuelles Passwort eingeben',
        submit: 'Mein Konto löschen',
        required: 'Gib dein aktuelles Passwort ein',
        success: 'Ihr Konto wurde gelöscht',
        error: 'Konto konnte nicht gelöscht werden',
      },
    },
    privacy: {
      title: 'Datenschutz und Sicherheit',
      blockedMembers: 'Blockierte Mitglieder',
      photoUnlockAuthorized: 'Freigaben für private Fotos',
      emptyHelp: {
        blocked:
          'Hier werden Mitglieder angezeigt, die du blockierst. Du kannst Sperren jederzeit aufheben.',
        photoUnlockAuthorized:
          'Hier werden Mitglieder angezeigt, denen du Zugriff auf deine privaten Fotos gewährt hast. Du kannst den Zugriff jederzeit widerrufen.',
      },
      removeUnlock: {
        title: 'Zugriff entfernen',
        action: 'Zugriff entfernen',
        confirmMessage: 'Zugriff auf Ihre privaten Fotos für {{userName}} entfernen?',
        success: 'Zugriff entfernt',
        error: 'Zugriff konnte nicht entfernt werden',
      },
    },
    language: 'Sprache',
    system: 'Wie System',
    community: 'Gemeinschaft',
    pattern: 'Kopfzeilen-Muster',
    patterns: {
      none: 'Keine',
      bones: 'Knochen und Pfoten',
      circles: 'Kreise',
      food: 'Essen',

      japanese: 'Japanisch',
      plaid: 'Kariert',
      polygonal: 'Polygonal',
      sprinkles: 'Streusel',
      stars: 'Sterne',
      triangles: 'Dreiecke',
    },
    appIcon: {
      title: 'App-Symbol',
      description: 'Wahle das Symbol, das auf deinem Startbildschirm erscheint.',
      changed: 'App-Symbol aktualisiert',
    },
    theme: {
      title: 'Design',
      auto: 'Wie System',
      light: 'Heller Modus',
      dark: 'Dunkler Modus',
    },
    units: {
      title: 'Einheiten',
      distance: 'Entfernung',
      distanceKm: 'Kilometer (km)',
      distanceMi: 'Meilen (mi)',
      height: 'Größe',
      heightM: 'Meter (m)',
      heightFt: 'Fuß (ft)',
      weightUnit: 'Gewicht',
    },
    diagnostics: {
      title: 'Diagnosetools',
      signalr: 'SignalR-Diagnose',
      clearCache: 'Cache leeren',
      cacheCleared: 'Cache erfolgreich geleert',
    },
    preferences: {
      title: 'Einstellungen',
      birthdayList: 'Geburtstagsliste',
      birthdayListDescription: 'Mich in der Geburtstagsliste anzeigen',
      anonymousViewing: 'Anonymes Ansehen',
      anonymousViewingDescription: 'Profile durchsuchen ohne in der Besucherliste zu erscheinen',
      inboundMessagePhotos: 'Eingehende Fotos',
      inboundMessagePhotosDescription:
        'Fotos in DMs von jedem erlauben (andernfalls nur von Personen, denen Sie folgen)',
      emailNotifications: 'E-Mail-Benachrichtigungen',
      emailNotificationsDescription: 'E-Mails für neue Nachrichten erhalten',
      photosInNewsfeed: 'Fotos im Newsfeed',
      photosInNewsfeedDescription: 'Beiträge mit Fotos im globalen Newsfeed anzeigen',
      mediaInComments: 'GIFs in Kommentaren anzeigen',
      mediaInCommentsDescription:
        'Zeigt GIFs und andere Medien in Kommentaren zu Beiträgen und Fotos an.',
      safeModeOff: 'Sensible und ungeprüfte Medien',
      safeModeOffDescription: 'Medien anzeigen, die sensible Inhalte enthalten können (NSFW)',
    },
    safety: {
      title: 'Sicherheitsoptionen',
    },
    notifications: {
      title: 'Benachrichtigungen',
      titleWithSounds: 'Benachrichtigungen & Töne',
      description: 'Wählen Sie aus, welche Aktivitäten Push-Benachrichtigungen auslösen',
      futureNotifications:
        'Die folgenden Push-Benachrichtigungen sind für die zukünftige Implementierung geplant und sind derzeit nicht aktiv.',
      newMessage: 'Neue Nachrichten',
      newMessageDescription: 'Wenn Ihnen jemand eine Nachricht sendet',
      newFollower: 'Neue Follower',
      newFollowerDescription: 'Wenn Ihnen jemand folgt',
      newPhotoComment: 'Foto-Kommentare',
      newPhotoCommentDescription: 'Wenn jemand Ihre Fotos kommentiert',
      newPostComment: 'Beitrags-Kommentare',
      newPostCommentDescription: 'Wenn jemand Ihre Beiträge kommentiert',
      newWallPost: 'Pinnwand-Beiträge',
      newWallPostDescription: 'Wenn jemand auf Ihrer Pinnwand postet',
      web: {
        mobileTitle: 'Push-Benachrichtigungen sind im Web nicht verfügbar',
        mobileSubtitle:
          'Installiere die iOS- oder Android-App, um Push-Benachrichtigungen zu erhalten, wenn dir jemand schreibt oder mit deinen Inhalten interagiert.',
        soundsDescription:
          'Wähle einen Ton, der bei neuen Ereignissen abgespielt wird. Die Töne werden vom Browser abgespielt, lass den {{communityName}}-Tab also geöffnet.',
        messageSoundLabel: 'Ton für neue Nachricht',
        notificationSoundLabel: 'Ton für neue Benachrichtigung',
        preview: 'Ton anhören',
        appStoreButton: 'Im App Store laden',
        googlePlayButton: 'Bei Google Play laden',
      },
      sounds: {
        off: 'Aus',
        trill: 'Triller',
        stepUp: 'Aufstieg',
        bubblePop: 'Blasen-Pop',
        marimba: 'Marimba',
        metro: 'Metro',
        retro: 'Retro',
        sparkle: 'Funkeln',
        strings: 'Streicher',
      },
    },
    dangerZone: 'Gefahrenbereich',
    about: {
      title: 'Über diese App',
      version: 'Version',
      build: 'Build',
      madeWithCities: 'Mit ❤️ gemacht in Montreal, New York und San Francisco',
      whatsNew: 'Neu in dieser Version',
    },
  },
  whatsNew: {
    title: 'Neuigkeiten',
    currentReleaseTitle: 'In dieser Version',
    catchUpReleaseTitle: 'Seit dem letzten Update',
    recentUpdatesTitle: 'Aktuelle Updates',
    lineageLabel: 'Version {{lineage}}',
    empty: 'Keine Neuigkeiten anzuzeigen.',
    neverShowAgain: 'Nie wieder anzeigen',
    showOnNewVersions: 'Dieses Fenster bei neuen Versionen anzeigen',
  },
  upgrade: {
    prompt: 'Erhalte Fotos in voller Größe in deinem Feed ohne Tageslimit',
    upgrade_button: 'Premium erhalten',
  },
  premium: {
    upgradeCard: {
      photos: '...und viele mehr! Upgraden Sie auf {{premiumPlan}}, um alle Fotos zu sehen.',
      members: '...und viele mehr! Upgraden Sie auf {{premiumPlan}}, um alle Mitglieder zu sehen.',
      conversation:
        'Upgrade auf {{premiumPlan}}, um auf deinen gesamten Gesprächsverlauf zuzugreifen.',
    },
  },
  paywall: {
    ViewFullsizePhoto:
      'Aktuelles Limit für das Anzeigen von Fotos in voller Größe erreicht. Upgraden Sie auf {{premiumPlanName}} für unbegrenzten Zugang.',
    OutgoingCommunication:
      'Aktuelles Limit für das Senden von Nachrichten und Beiträgen erreicht. Upgraden Sie auf {{premiumPlanName}} für unbegrenzte Kommunikation.',
    NewsfeedSearch:
      'Aktuelles Limit für Newsfeed-Suchen erreicht. Upgraden Sie auf {{premiumPlanName}} für unbegrenzte Suchen.',
    ValidateGiftCertificate: 'Aktuelles Limit für Geschenkgutschein-Validierungen erreicht.',
    Blocks:
      'Sie haben die maximale Anzahl blockierter Mitglieder erreicht. Upgraden Sie auf {{premiumPlanName}} für mehr Blockierungen.',
    BlockingAMember:
      'Sie haben dieses Mitglied kürzlich blockiert oder entblockt. Bitte warten Sie 3 Tage, bevor Sie es erneut blockieren oder entblocken.',
    PostsPerHour:
      'Sie haben Ihr stündliches Beitragslimit erreicht. Bitte warten Sie, bevor Sie erneut posten.',
    ChangeOfEmail:
      'Aktuelles Limit für E-Mail-Änderungsanfragen erreicht. Bitte versuchen Sie es morgen erneut.',
    PhotoStream:
      'Aktuelles Limit für das Anzeigen von Foto-Streams erreicht. Upgraden Sie auf {{premiumPlanName}} für unbegrenzten Zugang.',
    FeaturedPhotos:
      'Sie können nur ein Foto pro Stunde im globalen Newsfeed hervorheben. Bitte warten Sie, bevor Sie ein weiteres posten.',
    PhotoUnlockRequests:
      'Aktuelles Limit für Foto-Entsperranfragen erreicht. Upgraden Sie auf {{premiumPlanName}} für unbegrenzte Anfragen.',
    AnonymousViewing:
      'Anonymes Ansehen erfordert eine {{premiumPlanName}}-Mitgliedschaft. Upgraden Sie, um Profile zu durchsuchen, ohne in Besucherlisten zu erscheinen.',
    PostsPerDay:
      'Sie haben Ihr tägliches Beitragslimit erreicht. Bitte versuchen Sie es morgen erneut.',
    UploadedPhotos:
      'Sie haben Ihr Foto-Limit erreicht. Upgraden Sie auf {{premiumPlanName}}, um mehr Fotos hochzuladen.',
    UploadedPhotosPerDay:
      'Sie haben Ihr tägliches Foto-Upload-Limit erreicht. Upgraden Sie auf {{premiumPlanName}}, um heute mehr Fotos hochzuladen.',
    MemberSearch:
      'Du hast das tägliche Suchlimit erreicht. Upgrade auf {{premiumPlanName}} für unbegrenzte Suchen.',
    MyTypeFilterChange:
      'Du hast das tägliche Limit für Änderungen deines Typfilters erreicht. Upgrade auf {{premiumPlanName}}, um ihn jederzeit zu ändern.',
    default:
      'Diese Funktion erfordert ein {{premiumPlanName}}-Konto. Upgraden Sie, um fortzufahren.',
    resetIn: {
      minutes_one: 'Erneut versuchen in {{count}} Minute',
      minutes_other: 'Erneut versuchen in {{count}} Minuten',
      hours_one: 'Erneut versuchen in {{count}} Stunde',
      hours_other: 'Erneut versuchen in {{count}} Stunden',
    },
  },
  notFound: {
    title: 'Entschuldigung, wir können nicht finden, wonach Sie suchen.',
    goHome: 'Zurück zum Startbildschirm',
  },
  communitiesHeader: {
    title: 'Communities',
  },
  profile: {
    aboutMe: 'Über mich',
    stats: 'Statistiken',
    bio: 'Biografie',
    height: 'Größe',
    weight: 'Gewicht',
    gender: 'Geschlecht',
    origin: 'Herkunft',
    relationship: 'Beziehung',
    languages: 'Sprachen',
    interestedIn: 'Interessiert An',
    preferences: 'Präferenzen',
    lookingFor: 'Sucht',
    bodyTypesLiked: 'Körpertypen',
    bodyPartsLiked: 'Körpermerkmale',
    sexualInterests: 'Sexuelle Interessen',
    mutualKinks: 'Gemeinsame Fetische',
    // Shared field labels (used by search, profile view, and edit profile)
    identifyAs: 'Identifiziert sich als',
    relationshipStatus: 'Beziehungsstatus',
    bodyTypes: 'Körpertypen',
    bodyHair: 'Körperbehaarung',
    facialHair: 'Gesichtsbehaarung',
    communityKinks: 'Community-Fetische',
    otherKinks: 'Andere Fetische',
    // Section titles
    sections: {
      identity: 'Identität und Hintergrund',
      interestsAndKinks: 'Interessen und Kinks',
      bodyFeatures: 'Körpertypen und Merkmale',
    },
    // Units
    units: {
      weight: {
        pounds: 'Pfund (lb)',
        kilograms: 'Kilogramm (kg)',
        stones: 'Stones (st)',
        short: {
          lb: 'lb',
          kg: 'kg',
          st: 'st',
        },
        suffix: {
          lbs: 'lbs',
          kg: 'kg',
          st: 'st',
        },
      },
      height: {
        feet: 'Fuß (ft)',
        meters: 'Meter (m)',
        short: {
          ft: 'ft',
          m: 'm',
        },
        suffix: {
          m: 'm',
        },
      },
    },
    lastSeen: 'Zuletzt gesehen',
    lastVisitedYou: 'Profil besucht',
    notYet: 'Noch nicht',
    activity: 'Aktivität',
    joinDateWithCommunity: 'Bei {{communityName}} seit',
    seeAllPhotos: 'Alle sehen',
    followers: 'follower',
    followers_one: 'Follower',
    followers_other: 'Follower',
    following: 'folge ich',
    following_one: 'folge ich',
    following_other: 'folge ich',
    follows_you: 'Folgt dir',
    followersCount: '{{count}} Follower',
    followingCount: '{{count}} folge ich',
    followersOfUser: 'Follower von {{userName}}',
    followingOfUser: '{{userName}} folgt',
    tabs: {
      about: 'Über mich',
      posts: 'Beiträge',
      photos: 'Fotos',
      events: 'Veranstaltungen',
      weight: 'Gewicht',
      wall: 'Pinnwand',
    },
    photos: {
      public: 'Öffentlich',
      private: 'Privat',
      privateLocked: 'Private Fotos sind gesperrt',
      requestAccess: 'Zugriff anfordern',
      extendedPreviewNotice: 'Du siehst mehr Fotos, weil dieses Mitglied {{premiumPlan}} hat.',
      requestPending: 'Ihre Anfrage zum Zugriff auf private Fotos wartet auf Genehmigung',
      requestSubmitted: 'Zugriffsanfrage gesendet',
      requestFailed: 'Fehler beim Senden der Zugriffsanfrage',
    },
    wall: {
      empty: 'Keine Beiträge zum Anzeigen',
    },
    share: {
      title: 'Profil teilen',
      message: 'Schau dir {{userName}}s Profil an',
      shareProfile: 'Profil teilen',
    },
  },
  member: {
    notFound: 'Mitglied nicht gefunden',
    menu: {
      report: 'Mitglied melden',
      block: 'Mitglied blockieren',
      unblock: 'Mitglied entblocken',
      privatePhotosSection: 'Private Fotos',
      revokePrivatePhotos: {
        action: 'Zugriff entziehen',
        confirmTitle: 'Zugriff entziehen',
        confirmMessage:
          '{{userName}} kann deine privaten Fotos nicht mehr sehen. Diese Person kann dir später eine neue Anfrage senden.',
        success: 'Zugriff entzogen',
        error: 'Zugriff konnte nicht entzogen werden',
      },
      forfeitPrivatePhotos: {
        action: 'Abbestellen',
        confirmTitle: 'Abbestellen',
        confirmMessage:
          'Du kannst die privaten Fotos von {{userName}} nicht mehr sehen. Du kannst später erneut Zugriff anfordern.',
        success: 'Abbestellt',
        error: 'Abbestellen fehlgeschlagen',
      },
    },
    block: {
      confirmMessage:
        'Sind Sie sicher, dass Sie {{userName}} blockieren möchten? Diese Aktion kann für die nächsten 72 Stunden nicht rückgängig gemacht werden, um Belästigungen zu verhindern.',
      success: 'Mitglied erfolgreich blockiert',
      error: 'Fehler beim Blockieren des Mitglieds',
    },
    unblock: {
      confirmMessage:
        'Sind Sie sicher, dass Sie {{userName}} entblocken möchten? Diese Aktion kann für die nächsten 72 Stunden nicht rückgängig gemacht werden, um Belästigungen zu verhindern.',
      success: 'Mitglied erfolgreich entblockt',
      error: 'Fehler beim Entblocken des Mitglieds',
    },
    unfollow: {
      confirmTitle: 'Entfolgen',
      confirmMessage: 'Sind Sie sicher, dass Sie {{userName}} nicht mehr folgen möchten?',
      success: 'Sie folgen {{userName}} nicht mehr',
      error: 'Fehler beim Entfolgen des Mitglieds',
    },
    follow: {
      success: 'Sie folgen jetzt {{userName}}',
      error: 'Fehler beim Folgen des Mitglieds',
    },
    locked: {
      message:
        'Upgraden Sie auf {{premiumPlan}}, um unbegrenzt Mitgliederprofile durchsuchen zu können.',
    },
  },
  userMenu: {
    viewProfile: 'Mein Profil anzeigen',
    editProfile: 'Mein Profil bearbeiten',
    settings: 'Einstellungen',
    plans: 'Pläne & Abonnement',
    help: 'Hilfe & Support',
    feedback: 'Feedback',
    rules: 'Community-Regeln',
    browseCommunities: 'Communities durchsuchen',
    signOut: 'Abmelden',
  },
  editProfile: {
    title: 'Profil Bearbeiten',
    saveSuccess: 'Profil erfolgreich aktualisiert',
    saveError: 'Profil konnte nicht aktualisiert werden',
    loadError: 'Profil konnte nicht geladen werden',
    saving: 'Speichern...',
    sections: {
      basicInfo: 'Grundlegende Infos',
    },
    firstName: 'Vorname',
    firstNamePlaceholder: 'Gib deinen Vornamen ein',
    birthDate: 'Geburtsdatum',
    selectYear: 'Jahr auswählen',
    selectMonth: 'Monat auswählen',
    selectDay: 'Tag auswählen',
    selectHeight: 'Größe auswählen',
    weightGoal: 'Gewichtsziel',
    weightRangeError: 'Das Gewicht muss im zulässigen Bereich liegen',
    descriptionPlaceholder: 'Erzähl uns von dir...',
    textPlaceholder: 'Text eingeben...',
    notSet: 'Nicht festgelegt',
    identifyAs: 'Ich identifiziere mich als',
    myBodyType: 'Mein Körpertyp',
    bodyTypesLiked: 'Körpertypen die ich mag',
    bodyPartsLiked: 'Körperliche Merkmale die ich mag',
    myBodyHair: 'Meine Körperbehaarung',
    myFacialHair: 'Meine Gesichtsbehaarung',
    hints: {
      firstName: 'Optional. Erscheint in deinem Profil nach deinem Benutzernamen.',
      birthDate:
        'Nicht für andere Benutzer sichtbar. Wird verwendet um zu überprüfen, dass du volljährig bist und dein Alter anzuzeigen.',
      bio: 'Erzähle anderen von dir, was du magst und wonach du suchst.',
    },
  },
  account: {
    plans: {
      title: 'Pläne und Abonnement',
      includedWith: 'Was ist in {{planName}} enthalten',
      choosePlan: 'Wählen Sie Ihren Plan',
      terms: 'Bedingungen',
      bestValue: 'BESTER WERT',
      monthlyPlan: '{{planName}} Monatsplan',
      yearlyPlan: '{{planName}} Jahresplan',
      regularPrice: 'Regulärer Preis',
      perMonth: 'pro Monat',
      perYear: 'pro Jahr',
      onlyPerMonth: 'Nur {{price}}/Monat (sparen Sie {{percent}}%)',
      pricesIn: 'Preise in {{currency}}.',
      billingTerms_ios:
        'Die Zahlung wird nach Bestätigung des Kaufs von Ihrem Apple-Konto abgebucht. Pläne sind für die von Ihnen gewählte Laufzeit gültig und verlängern sich automatisch zum angegebenen Preis, sofern sie nicht mindestens 24 Stunden vor Ende des aktuellen Zeitraums gekündigt werden. Sie können Ihr Abonnement jederzeit in den Einstellungen Ihres Geräts oder über Abonnement verwalten oben kündigen.',
      billingTerms_android:
        'Die Zahlung wird nach Bestätigung des Kaufs von Ihrem Google-Konto abgebucht. Pläne sind für die von Ihnen gewählte Laufzeit gültig und verlängern sich automatisch zum angegebenen Preis, sofern sie nicht mindestens 24 Stunden vor Ende des aktuellen Zeitraums gekündigt werden. Sie können Ihr Abonnement jederzeit in den Einstellungen Ihres Geräts oder über Abonnement verwalten oben kündigen.',
      billingTerms_web:
        'Abonnementbedingungen und Abrechnungsdetails werden beim Checkout bereitgestellt. Ihr Abonnement verlängert sich automatisch, sofern es nicht vor dem Verlängerungsdatum gekündigt wird.',
      privacyPolicy: 'Datenschutzrichtlinie',
      termsOfUse: 'Nutzungsbedingungen',
      manageSubscription: 'Abonnements verwalten',
      currentPlan: 'Aktueller Plan',
      loading: 'Pläne werden geladen...',
      confirming: 'Dein Abo wird bestätigt...',
      connecting: 'Verbindung zum Store...',
      connectionError: 'Verbindungsfehler',
      openPlayStore: 'Play Store öffnen',
      signInToPlayStore: 'Melden Sie sich bei Google Play Store an, um fortzufahren',
      openAppStore: 'App Store öffnen',
      checkAppStoreConnection:
        'Überprüfen Sie Ihre App Store-Verbindung und versuchen Sie es erneut',
      premiumFeatures: {
        unlimitedPhotos: 'Unbegrenzte Fotoansicht',
        featureMorePhotosToRegularMembers: 'Zeige Mitgliedern ohne Abo mehr von deinen Fotos',
        unlimitedMessaging: 'Unbegrenzte Nachrichten',
        moreBlocks: 'Mehr Blockierungen',
        morePhotoUploads: 'Mehr Foto-Uploads',
      },
      learnMoreAboutPlans: 'Erfahre alles über unsere Pläne',
      yourAccountIsOn: 'Ihr Konto verwendet den {{planName}}-Plan',
      currentCreditsUntil: 'Aktuelle Credits gültig bis:',
      daysLeft_one: 'Noch {{count}} Tag',
      daysLeft_other: 'Noch {{count}} Tage',
      hoursLeft_one: 'Noch {{count}} Stunde',
      hoursLeft_other: 'Noch {{count}} Stunden',
      subscriptionRenewalNote:
        'Ihr Abonnement verlängert sich automatisch basierend auf Ihrem Abrechnungszyklus. Jede Verlängerung fügt Credits zu Ihrem Konto hinzu. Credits aus Werbeaktionen oder Geschenkgutscheinen können über Ihre aktuelle Abonnementperiode hinausgehen. Vielen Dank, dass Sie {{planName}}-Mitglied sind!',
      billingNotAvailable: 'Abonnements sind derzeit nicht verfügbar',
      grandfatheredPricing:
        'Glückwunsch! Sie profitieren von unseren früheren niedrigeren Preisen.',
      oneMonth: 'Monatlich',
      threeMonths: 'Vierteljährlich',
      oneYear: 'Jährlich',
      oneYearCombo: 'Jährliches Duo',
      comboSubtitle: 'Enthält Grommr XL und 1 Jahr Chasable+ (Geschenkgutschein)',
      every3Months: 'alle 3 Monate',
      save: '{{percent}}% sparen',
      renewsEveryDays: 'Verlängert sich automatisch alle {{days}} Tage',
      subscribe: 'Abonnieren',
      subscribed: 'Abonniert',
      manageCCBill: 'CCBill-Abonnement kündigen/verwalten',
      subscriptionIdLabel: 'Ihre neueste CCBill-Abonnement-ID',
      subscriptionIdCopied: 'Abonnement-ID in die Zwischenablage kopiert',
      ccbillPayments: 'CCBill-Zahlungen (Abonnements)',
      ccbillDescription:
        'Wir verwenden CCBill zur Abwicklung unserer Abrechnung und es gibt verschiedene Möglichkeiten, Ihren Pass per Kreditkarte zu kaufen: Wir akzeptieren Visa, Mastercard, JCP und Discover. Auf Ihrer Kreditkartenabrechnung erscheint "CCBill.Com *Grokio" (Grokio Communities LLC ist das Betriebsunternehmen hinter {{communityName}}). Sie haben die Möglichkeit, Ihre Transaktion in einer von fünf Währungen durchzuführen: USD; EUR; GBP; CAD; AUD; und JPY. Sobald wir die Bestätigung erhalten, dass die Zahlung erfolgt ist, wird die neue Zeit Ihrem Konto hinzugefügt (in den meisten Fällen sollte dies sofort geschehen). Alle Abonnements über CCBill verlängern sich automatisch. Wenn Sie Ihr Abonnement kündigen möchten, können Sie den bereitgestellten Link verwenden und es mindestens 48 Stunden vor der Verlängerung kündigen.',
      billingFaq: 'Abrechnungsinformationen und FAQ',
      billingFaqDescription:
        'Schauen Sie sich unser {{planName}}-Abrechnungsinformationsdokument an, um Details zu Zahlungen, Verlängerungen und Kündigungen zu erhalten.',
      billingFaqGuide: 'Leitfaden zu {{planName}}',
      getBillingSupport: 'Abrechnungssupport erhalten',
      restorePurchases: 'Käufe wiederherstellen',
      error: {
        loadProducts: 'Laden der Abonnementpläne fehlgeschlagen',
        noProductsFound: 'Keine Abonnementprodukte gefunden',
        purchase: 'Kauf fehlgeschlagen',
        purchasePayment:
          'Dein Kauf konnte nicht abgeschlossen werden. Überprüfe deine Zahlungsmethode und versuche es erneut.',
        purchaseNetwork:
          'Verbindung zum Store nicht möglich. Überprüfe deine Internetverbindung und versuche es erneut.',
        purchaseUnavailable: 'In-App-Käufe sind auf diesem Gerät oder Konto nicht verfügbar.',
        purchaseAlreadyOwned: 'Du hast bereits ein aktives Abonnement für diesen Plan.',
        purchaseDeferred:
          'Deine Zahlung wartet auf Genehmigung. Das Abonnement wird nach der Genehmigung aktiviert.',
        purchaseItemUnavailable: 'Dieser Abonnementplan ist derzeit nicht verfügbar.',
        validation: 'Validierung des Kaufs fehlgeschlagen',
        restore: 'Wiederherstellung fehlgeschlagen — versuche es erneut oder kontaktiere den Support',
        restoreUnavailable:
          'Store nicht erreichbar. Überprüfe deine Verbindung und versuche es erneut.',
      },
      success: {
        subscribedWithPlan:
          'Vielen Dank für Ihr Abonnement! Ihr {{planName}}-Plan ist jetzt aktiv.',
        subscribedWithBogo:
          'Vielen Dank für Ihr Abonnement! Ihr {{planName}} ist jetzt aktiv. Bonus: Sie haben mit unserer Aktion einen zusätzlichen {{period}} erhalten!',
        restored: 'Käufe erfolgreich wiederhergestellt',
        nothingToRestore: 'Keine Käufe zum Wiederherstellen',
      },
    },
    transactions: {
      title: 'Transaktionsverlauf',
      empty: 'Noch keine Transaktionen',
      days_one: 'Tag',
      days_other: 'Tage',
      header: {
        date: 'Datum',
        description: 'Beschreibung',
      },
    },
    certificates: {
      title: 'Geschenkgutscheine',
      history: 'Deine Geschenkgutscheine',
      empty: 'Noch keine Geschenkgutscheine',
      purchase: 'Geschenkgutschein-Kauf',
      redeemed: 'Geschenkgutschein eingelöst',
      redeemedOn: 'Eingelöst am {{date}}',
      codeCopied: 'Gutscheincode in die Zwischenablage kopiert',
      redeem: {
        title: 'Geschenkgutschein einlösen',
        helper: 'Gib den Code ein, den du erhalten hast, um deinem Konto Premium-Zeit hinzuzufügen.',
        placeholder: 'XXXXX-XXXXX-XXXXX-XXXXX-XXXXX',
        button: 'Einlösen',
        success_one: 'Geschenkgutschein eingelöst! {{count}} Tag wurde deinem Konto hinzugefügt.',
        success_other: 'Geschenkgutschein eingelöst! {{count}} Tage wurden deinem Konto hinzugefügt.',
        invalidFormat: 'Das sieht nicht wie ein Geschenkgutscheincode aus. Codes bestehen aus 25 Buchstaben und Ziffern.',
        notFound: 'Wir konnten diesen Code nicht finden. Stelle sicher, dass du ihn in der Community einlöst, für die er ausgestellt wurde.',
        alreadyRedeemed: 'Dieser Geschenkgutschein wurde bereits eingelöst.',
        tooManyAttempts: 'Zu viele Versuche. Versuche es morgen erneut.',
        error: 'Wir konnten diesen Geschenkgutschein nicht einlösen. Versuche es später erneut.',
      },
      header: {
        date: 'Datum',
        details: 'Details',
      },
    },
  },
  webDrop: {
    dropToUpload: 'Bild ablegen, um hochzuladen',
    dragHint: 'Ziehe ein JPG/PNG-Bild hierher',
  },
  weightHistory: {
    stats: 'Statistiken',
    currentWeight: 'Aktuell',
    trend: 'Trend',
    bmi: 'BMI',
    goal: 'Ziel',
    perMonth: '/Monat',
    history: 'Verlauf',
    date: 'Datum',
    weight: 'Gewicht',
    notes: 'Notizen',
    noData: 'Noch keine Gewichtseinträge',
    noChartData: 'Nicht genügend Daten für das Diagramm',
    addRecord: 'Hinzufügen',
    editRecord: 'Gewicht bearbeiten',
    selectDate: 'Datum auswählen',
    notesPlaceholder: 'Optionale Notizen...',
    added: 'Gewicht hinzugefügt',
    updated: 'Gewicht aktualisiert',
    deleted: 'Gewichtseintrag gelöscht',
    saveFailed: 'Speichern fehlgeschlagen',
    deleteFailed: 'Löschen des Eintrags fehlgeschlagen',
    deleteTitle: 'Löschen',
    deleteConfirm: 'Diesen Gewichtseintrag löschen?',
  },
  footer: {
    support: 'Support',
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutzerklärung',
  },
  report: {
    reasonTitle: 'Warum meldest du das?',
    rulesLink: 'Lies die Community-Regeln',
    reasons: {
      scam: 'Betrüger',
      spam: 'Spam',
      falsePortrayal: 'Falsche Identität',
      harassment: 'Belästigung',
      intolerance: 'Intoleranz',
      trolling: 'Trolling',
      disparagement: 'Herabwürdigung',
      donationRequest: 'Spendenaufruf',
      promotionalPosting: 'Verstoß gegen Werberegeln',
      photoPolicy: 'Verstoß gegen die Fotorichtlinie',
      uncreditedArtwork: 'Kunstwerk ohne Quellenangabe',
      underage: 'Minderjährig',
      illegalActivity: 'Sonstige illegale Aktivitäten',
      other: 'Sonstiges',
    },
  },
};
